import { render, staticRenderFns } from "./expressInterception.vue?vue&type=template&id=4127e533&scoped=true"
import script from "./expressInterception.vue?vue&type=script&lang=js"
export * from "./expressInterception.vue?vue&type=script&lang=js"
import style0 from "./expressInterception.vue?vue&type=style&index=0&id=4127e533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127e533",
  null
  
)

export default component.exports